import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import baseURL from '../url';
import storage from '../storage';

const CajaContext = createContext({
    caja: null,
    loading: true,
    abrirCaja: () => {},
    cerrarCaja: () => {},
    refrescarCaja: () => {},
});

export function CajaProvider({ children }) {
    const [caja, setCaja] = useState(null);
    const [cajasAbiertas, setCajasAbiertas] = useState([]);
    const [loading, setLoading] = useState(true);

    const getUsuario = () => {
        const g = storage.getItem('adminUser');
        return g ? JSON.parse(g) : null;
    };

    const refrescarCaja = useCallback(async () => {
        const usuario = getUsuario();
        if (!usuario?.idUsuario) { setLoading(false); return; }
        try {
            const res = await fetch(`${baseURL}/cajaActualGet.php?idTrabajador=${usuario.idUsuario}`);
            const data = await res.json();
            setCaja(data.caja && typeof data.caja === 'object' ? data.caja : null);
            setCajasAbiertas(data.cajasAbiertas || []);
        } catch (err) {
            setCaja(null);
            setCajasAbiertas([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const abrirCaja = async (montoInicial, idSucursal = null) => {
        const usuario = getUsuario();
        if (!usuario?.idUsuario) return { error: 'No hay usuario' };
        const formData = new FormData();
        formData.append('idTrabajador', usuario.idUsuario);
        formData.append('montoInicial', montoInicial);
        if (idSucursal) formData.append('idSucursal', idSucursal);
        const res = await fetch(`${baseURL}/cajaPost.php`, { method: 'POST', body: formData });
        const data = await res.json();
        if (data.caja) {
            setCaja(data.caja);
        } else if (data.idCaja) {
            await refrescarCaja();
        }
        return data;
    };

    const unirseCaja = async (idCaja) => {
        const usuario = getUsuario();
        if (!usuario?.idUsuario) return { error: 'No hay usuario' };
        const formData = new FormData();
        formData.append('idCaja', idCaja);
        formData.append('idTrabajador', usuario.idUsuario);
        const res = await fetch(`${baseURL}/cajaUnirsePost.php`, { method: 'POST', body: formData });
        const data = await res.json();
        if (data.mensaje || data.idCaja) {
            await refrescarCaja();
        }
        return data;
    };

    const cerrarCaja = async (montoFinal, nota = '', montoTransferenciaFinal = null, transferenciasPorMetodo = null) => {
        if (!caja?.idCaja) return { error: 'No hay caja abierta' };
        const res = await fetch(`${baseURL}/cajaPut.php`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ idCaja: caja.idCaja, montoFinal, nota, montoTransferenciaFinal, transferenciasPorMetodo }),
        });
        const data = await res.json();
        if (data.mensaje) {
            setCaja(null);
        }
        return data;
    };

    useEffect(() => { refrescarCaja(); }, [refrescarCaja]);

    return (
        <CajaContext.Provider value={{ caja, cajasAbiertas, loading, abrirCaja, unirseCaja, cerrarCaja, refrescarCaja }}>
            {children}
        </CajaContext.Provider>
    );
}

export function useCaja() {
    return useContext(CajaContext);
}
